export enum Env {
  Production = 'production',
  Staging = 'staging',
  Development = 'development',
}

const ENV_ORIGIN_MAP: Record<string, Env> = {
  'onboarding.autocut.io': Env.Production,
  'onboarding.autocut.com': Env.Production,
  localhost: Env.Development,
};

export const CURRENT_ENV =
  ENV_ORIGIN_MAP[window.location.hostname] || Env.Staging;
export const IS_RUNNING_ON_ELECTRON = navigator.userAgent.includes('AutoCut');
